var exports = {
  "t": "xe533113f--5f8c4e--skeleton-list",
  "q": "xe533113f--5f8c4e--skeleton-item",
};

module.exports = exports;
